import React, { useEffect, useState } from 'react';
import "../OrderCom/Order.css";
import Logo from "../../Images/Woodsy.png";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { RiArrowDownSLine } from "react-icons/ri";
import { Avatar, Dropdown, Space, message } from 'antd'; // Import message for better feedback
import OrderList from './OrderList';
import Profile from '../ProfileCom/Profile';
import Settings from '../SettingCom/Settings'; // Ensure this path is correct
import { AiOutlineUser } from "react-icons/ai";
import { useDispatch } from 'react-redux';
import { unSetUserToken } from '../../features/authSlice';

const Order = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedComponent, setSelectedComponent] = useState('OrderList');

    const profileData = JSON.parse(localStorage.getItem('profile'));
    // console.log("profileData from localStorage:", profileData); // Keep this for debugging if needed

    const logoutHandle = () => {
        try {
            localStorage.removeItem('access_token');
            localStorage.removeItem('profile');
            dispatch(unSetUserToken()); // Dispatching with no payload as per recent change
            navigate('/');
            message.success("Logged out successfully!"); // Provide user feedback
        } catch (error) {
            console.error("Logout failed:", error);
            message.error("Failed to log out. Please try again.");
        }
    };

    // Sync selectedComponent with current path
    useEffect(() => {
        const path = location.pathname;
        console.log("Current path:", path); // Debugging: See what the path is

        if (path.includes('profile')) {
            setSelectedComponent('Profile');
            console.log("Selected component: Profile"); // Debugging
        } else if (path.includes('settings')) {
            setSelectedComponent('Settings');
            console.log("Selected component: Settings"); // Debugging
        } else if (path.includes('order')) { // Explicitly handle /order path
            setSelectedComponent('OrderList');
            console.log("Selected component: OrderList"); // Debugging
        } else {
             // Fallback for paths that don't match or initial load
            setSelectedComponent('OrderList');
            console.log("Selected component: OrderList (default)"); // Debugging
        }
    }, [location.pathname]);

    // Logging selectedComponent change
    useEffect(() => {
        console.log("selectedComponent state changed to:", selectedComponent);
    }, [selectedComponent]);

    const items = [
        {
            key: '1',
            label: (
                <div className='order-profile-head-info-main-con'>
                    <div className='order-profile-head-info-image-and-name-main-con'>
                        <div className='Profile-dropdown-profile-name-con'>
                            <Avatar
                                size="large"
                                src={profileData?.profile_picture_url || undefined} // Assuming this is the correct field from your profile data
                                icon={!profileData?.profile_picture_url && <AiOutlineUser />}
                            />
                        </div>
                        <div className='order-profile-name-and-email-con'>
                            <h4>{profileData?.name || "Guest"}</h4> {/* Add a default name */}
                            <h5>{profileData?.email || "N/A"}</h5>  {/* Add a default email */}
                        </div>
                    </div>
                </div>
            ),
            disabled: true,
        },
        {
            key: '2',
            label: (
                // Use onClick for internal state change, or rely solely on Link + useEffect
                // Link is generally preferred for navigation
                <Link to="/profile" className='Profile-drop-down-link'>
                    Profile
                </Link>
            ),
        },
        // {
        //     key: '3',
        //     label: (
        //         <Link to="/settings" className='Profile-drop-down-link'>
        //             Settings
        //         </Link>
        //     ),
        // },
        {
            key: '4',
            label: (
                <Link to="/order" className='Profile-drop-down-link'>
                    Order
                </Link>
            ),
        },
        {
            key: '5',
            label: (
                <div className='Profile-drop-down-link' onClick={logoutHandle}>
                    Log Out
                </div>
            ),
        },
    ];

    return (
        <section className='order-main-section'>
            <section className='Order-section-1'>
                <div className='order-section-head-con-main'>
                    <div className='container'>
                        <div className='order-section-head-bar'>
                            <div className='order-section-logo-and-order-btn-con'>
                                <div className='order-section-logo-image-con'>
                                    <img src={Logo} alt='Logo' />
                                </div>
                                <div className='Order-section-bar-order-text'>
                                    <h3>Orders</h3>
                                </div>
                            </div>
                            <div className='order-section-bar-profile-dropdown-and-store-main-con'>
                                <div className='order-section-bar-profile-dropdown-btn'>
                                    <Dropdown menu={{ items }}>
                                        <a onClick={(e) => e.preventDefault()}>
                                            <Space>
                                                <div className='Profile-dropdown-profile-name-con'>
                                                    {/* Ensure profileData?.image is the correct field for the Avatar here */}
                                                    <Avatar
                                                        size="large"
                                                        src={profileData?.profile_picture_url || undefined} // Assuming this is correct
                                                        icon={!profileData?.profile_picture_url && <AiOutlineUser />}
                                                    />
                                                </div>
                                                <RiArrowDownSLine />
                                            </Space>
                                        </a>
                                    </Dropdown>
                                </div>
                                <div className='order-section-bar-store-btn-con'>
                                    <Link to="/">
                                        <button>Go to store</button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Conditional Rendering of Components */}
            {selectedComponent === 'OrderList' && <OrderList />}
            {selectedComponent === 'Profile' && <Profile />}
            {/* {selectedComponent === 'Settings' && <Settings />} */}
        </section>
    );
};

export default Order;